import ListView from "./listView";
import {RelationType} from "../relationType";
import Organization from "../organization";
import PublishedObjectModel from "../objectModels/publishedObjectModel";
import {ObjectModelDefaultActionType} from "~/enums/objectModelDefaultActionType";
import ObjectModelAction from "~/models/objectModelActions/objectModelAction";

export default class PublishedListView extends ListView {
  u_at: string;
  c_at: string;
  list_view_id: string;
  object_model_id:string;
  title: string;
  author: any;
  organization: Organization;
  published_object_model: PublishedObjectModel;
  available_action_client_ids: Array<string>;

  get EMBEDDED_MODELS(): {[key: string]: {type: any, relationType: RelationType}} {
    return {
      published_object_model: {type: PublishedObjectModel, relationType: RelationType.singleObject},
      ...ListView.EMBEDDED_MODELS,
    };
  }

  get defaultCreateAction(): ObjectModelAction {
    return this.published_object_model.objectModelDefaultActionsArray
      .find(a => a.default_action_type === ObjectModelDefaultActionType.Create);
  }

  get publishedObjectModel(): PublishedObjectModel {
    return this.published_object_model;
  }
}